var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyGenderMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5258 2.01293C13.7954 2.0684 13.9981 2.30751 13.9986 2.59343L14 4.79905C14.0002 5.12645 13.7353 5.39203 13.408 5.39249C13.0806 5.39273 12.8151 5.1278 12.8146 4.80049V4.02457L11.267 5.5721C12.893 7.61403 12.7631 10.5937 10.8762 12.4806L10.6822 12.6646C8.64298 14.5065 5.49305 14.4428 3.52511 12.4749C1.55716 10.5069 1.49354 7.35702 3.33544 5.31777L3.51936 5.12379C5.40625 3.23689 8.38597 3.10698 10.4279 4.73296L11.9754 3.18543H11.1995C10.8722 3.18494 10.6073 2.91937 10.6075 2.592C10.608 2.26465 10.8736 1.99976 11.2009 2L13.4066 2.00144L13.5258 2.01293ZM10.0328 5.96724C8.46325 4.39773 5.922 4.39799 4.35778 5.96221C2.79393 7.52646 2.79415 10.0671 4.36353 11.6365C5.93291 13.2059 8.47354 13.2061 10.0378 11.6422C11.602 10.078 11.6023 7.53675 10.0328 5.96724Z",
    fill: "#1865D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyGenderMale);
export default __webpack_public_path__ + "static/media/family-gender-male.3bad13e030ac3a898c0114819fa4c396.svg";
export { ForwardRef as ReactComponent };